import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { GlobalState } from '../../../../GlobalState'
import { TabTitle } from '../../../../util/titleChanger'
import { api } from '../../../../util/urlConfig'
import './userview.css'

export default function UserView() {
    TabTitle('View User')
    const { userId } = useParams();
    const state = useContext(GlobalState)
    const [userDetail] = state.userAPI.userDetail;
    const [id, setId] = state.userAPI.id

    const [values, setValues] = useState('')

    useEffect(() => {
        if (userId > 0) {
            setId(userId);
            var today = new Date();
            var createDate = new Date(userDetail.created_at)
            setValues({
                ...values,
                user_code: userDetail.user_code,
                first_name: userDetail ? userDetail.first_name : "Test",
                last_name: userDetail ? userDetail.last_name : "Test",
                nic: userDetail ? userDetail.nic : "Test",
                contact_no: userDetail ? userDetail.contact_no : "Test",
                email: userDetail ? userDetail.email : "test@mail.com",
                status: userDetail ? userDetail.status : "Test",
                image_url: userDetail.upload_image ? userDetail.upload_image.image_url : '/img/dummy_avatar.png',
                role: userDetail.role ? userDetail.role.name : "Not Assign",
                create_at: userDetail.created_at ? createDate.toLocaleDateString('ja-JP') : today.toLocaleDateString('ja-JP')
            });
        }
    }, [id, userId, userDetail])
    return (
        <div className="profile-main-container">
            <div className="profile-container">
                <div className="left-container">
                    <img src={api + "/" + values.image_url} alt="avatar" />
                </div>
                <div className='right-container'>
                    <div className="action">
                        <Link to={`/user-form/${userId}`}><i className="uil uil-pen"></i><button></button></Link>
                    </div>
                    <div className="name-title">
                        <h2>{values.first_name + " " + values.last_name}</h2>
                        <p>{values.user_code}</p>
                    </div>
                    <div className="user-content">
                        <p>Position : <span>{values.role}</span></p>
                        <p>Email : <span>{values.email}</span></p>
                        <p className='status'>Status : <span>{values.status}</span></p>
                        <p>NIC : <span>{values.nic}</span></p>
                        <p>Contact No : <span>{values.contact_no}</span></p>
                        <p>Created At : <span>{values.create_at}</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}
